import emptySplitApi from "../utils/rtk";
import { User, updateProfile } from "../types/User";
import { END_POINTS } from "../helpers";
import { CommonBody } from "../types/General";

type CommonResponseType = {
  statusCode: number;
  message: string;
  s3Location?: string;
};

type PostLoginBody = {
  email: string;
  password: string;
};
type queryUser = {
  page: number;
  search: string;
};
export const tutorReport = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    tutorReport: builder.query<
      CommonResponseType & { data: any },
      { status?: number; page?: number; search?: string }
    >({
      query: ({ status, page, search }) => {
        let url = END_POINTS.tutorReport;
        const queryParams = [];
        if (page) {
          queryParams.push(`page=${page}`);
        }
        if (search) {
          queryParams.push(`search=${search}`);
        }
        if (status) {
          queryParams.push(`status=${status}`);
        }
        // if (limit) {
        //   queryParams.push(`limit=${limit}`);
        // }
        // if (value != undefined) queryParams.push(`supportType=${value + 1}`);
        if (queryParams.length > 0) {
          url += `?${queryParams.join("&")}`;
        }

        return {
          url: url,
          method: "GET",
        };
      },
    }),

    revertTutorReport: builder.mutation<
      CommonResponseType & { data: CommonBody },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: `${END_POINTS.revertTutorReport}`,
        method: "POST",
        body,
      }),
    }),

    EditUser: builder.mutation<
      CommonResponseType & { data: CommonBody },
      { id: string | undefined; body: CommonBody }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateParent}/${id}`,
        method: "PUT",
        body,
      }),
    }),

    deleteTutorReport: builder.query<
      CommonResponseType & { data: any },
      { id: any }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.tutorReport}/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useRevertTutorReportMutation,
  useLazyTutorReportQuery,
  useDeleteTutorReportQuery,
  useLazyDeleteTutorReportQuery,
} = tutorReport;
